// import acceptedBadge from "../../assets/images/acceptedBadge.svg";
// import rejectedBadge from "../../assets/images/rejectedBadge.svg";
import acceptedBadge from "../../assets/images/acceptedBadge_1.svg";
import rejectedBadge from "../../assets/images/rejectedBadge_1.svg";
import parentClauseBadge from "../../assets/images/parentClause.svg";
import Tooltip from "../Tooltip/Tooltip";
import Typography from "../Typography/Typography";

const Badge = ({
  data,
  parentData,
  parentDocName,
}: {
  data: { is_present?: boolean; contract_content: string; category: string };
  parentData?: { is_present?: boolean; category: string }[];
  parentDocName?: string;
}) => {
  const isParentClausePresent = parentData?.some(
    (parentClause) =>
      parentClause.category === data.category && parentClause.is_present
  );

  const badgeSrc = isParentClausePresent
    ? parentClauseBadge
    : data.is_present
    ? acceptedBadge
    : rejectedBadge;
  const badge = <img style={{ marginRight: "auto" }} src={badgeSrc} alt="" />;

  const tooltipContent = isParentClausePresent ? (
    <Typography
      fontFamily="Open Sans"
      fontWeight={600}
      fontSize={11}
      lineHeight="14px"
      letterSpacing="0%"
      textAlign="center"
    >
      This clause is available in the parent document -{" "}
      <span>{parentDocName}</span>
    </Typography>
  ) : data.is_present ? (
    data.contract_content
  ) : (
    "Clause not found"
  );

  return data?.is_present && !data?.contract_content ? (
    badge
  ) : (
    <Tooltip
      title={tooltipContent}
      placement="bottom"
      overlayInnerStyle={{ overflow: "auto", maxHeight: "300px" }}
    >
      {badge}
    </Tooltip>
  );
};

export default Badge;
